export const getFontFamilies = () => [
    { name: 'Sans Serif', value: 'sans-serif' },
    { name: 'Serif', value: 'serif' },
    { name: 'Monospace', value: 'monospace' },
    { name: 'Comic', value: 'Comic Sans MS' },
    { name: 'Cursive', value: 'cursive' },
]